import React from "react"
import { PERIOD_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const PeriodAutoSuggest = (props) => {
    const periodSuggest = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        } else {
            q = "";
        }

        return Promise.resolve(
            Object
                .keys(PERIOD_DICTIONARY)
                .filter(periodKey => (PERIOD_DICTIONARY[periodKey] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        )
    };

    return (
        <AutoSuggest
            label="Period"
            fetchOptions={periodSuggest}
            renderOption={period => ({
                value: period,
                label: PERIOD_DICTIONARY[period]
            })}
            optionIdentifier={(project) => project}
            {...props}
        />
    );
}

export default PeriodAutoSuggest;
